export default __webpack_public_path__ + "static/logo_ioi-b47d74e9ef6d17d72c2a237008f6316c.png";